import { ChangeDetectorRef } from '@angular/core';
import { finalize, Observable } from 'rxjs';

export function detectChangesOnFinalize(cdr: ChangeDetectorRef) {
    return function <T>(source$: Observable<T>) {
        return source$.pipe(
            finalize(() => {
                cdr.detectChanges();
            })
        );
    };
}
